import { truncate } from '../utils/format';

import { CHROME } from './palette';

interface AxisTickProps {
  x?: number;
  y?: number;
  payload?: { value: string | number };
  /** Characters to keep before the ellipsis. */
  max: number;
}

/**
 * A category tick that cannot wrap.
 *
 * Recharts renders axis labels through its own Text component, which breaks a
 * label into tspans to fit the axis width — and it counts the trailing ellipsis
 * of a truncated label as a word, so a name well inside the width still spills
 * onto a second line and crowds its neighbour. A single <text> has nothing to
 * wrap with, so the label is always one line and the tooltip carries the rest.
 */
export function AxisTick({ x = 0, y = 0, payload, max }: AxisTickProps) {
  return (
    <text x={x} y={y} dy={4} textAnchor="end" fill={CHROME.inkSecondary} fontSize={11}>
      {truncate(String(payload?.value ?? ''), max)}
    </text>
  );
}
